import { ScanHistoryPage } from '@/pages/scan-history';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/scan-history')({
	component: ScanHistoryPage,
});
